import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class ZakaznikKontaktProvider extends BaseApi {
	ChangeToFirma(id: string | number | null) {
		return this.update(`/${DMS_MODULE}/${NAME}/ChangeToFirma/${id}`);
	}

	ChangeToFO(id: string | number | null) {
		return this.update(`/${DMS_MODULE}/${NAME}/ChangeToFyzOsoba/${id}`);
	}
}

export const apiProvider = new ZakaznikKontaktProvider(DMS_MODULE, NAME);
